import React from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const Chip = styled(Box)(({ theme }) => ({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',

    padding: '8px 14px',
    borderRadius: '999px',

    backgroundColor: 'rgba(255,255,255,0.06)',
    border: '1px solid rgba(255,255,255,0.12)',

    color: '#B1B5C3',
    fontWeight: 600,
    fontSize: '0.95rem',

    margin: '0 auto 0',

    '@media (max-width:600px)': {
        fontSize: '0.75rem',
        padding: '6px 12px',
    },
}));

const FIUChip = ({ children, sx = {}, ...props }) => {
    return (
        <Chip
            {...props}
            sx={sx}
        >
            {children}
        </Chip>
    );
};

export default FIUChip;